import { GetStoresParamsType } from '@bounty/schemas'

export type ShopSortOrder = {
  name: string
  value: string
  orderBy: GetStoresParamsType['orderBy']
  orderByDirection: 'ASC' | 'DESC'
}

export const SORT_ORDERS: ShopSortOrder[] = [
  {
    name: 'Recommended',
    value: 'recommended',
    orderBy: 'RECOMMENDED',
    orderByDirection: 'ASC',
  },
  {
    name: 'Highest Paying',
    value: 'highestPaying',
    orderBy: 'HIGHEST_PAYING',
    orderByDirection: 'DESC',
  },
  {
    name: 'First Time Minimum Payout',
    value: 'minimumPayout',
    orderBy: 'MINIMUM_PAYOUT',
    orderByDirection: 'DESC',
  },
  {
    name: 'Recently Added',
    value: 'recentlyAdded',
    orderBy: 'RECENTLY_ADDED',
    orderByDirection: 'DESC',
  },
  {
    name: 'A-Z',
    value: 'storeName',
    orderBy: 'STORE_NAME',
    orderByDirection: 'ASC',
  },
]
